import React from 'react';
import meImage from '../assets/images/me2.png';
import './me.css'
import { Link as ScrollLink } from 'react-scroll';

function Me() {
  return (
    <>
      <section id="me">
        <div className="me">
          <div className="meImg">
            <img src={meImage} alt="Me" id='meImg' />

          </div>

          <div className="me-data">
            <h4>Hello, I'm</h4>
            <h1>Håkon Asdøl</h1>
            <h4>Web Developer </h4>
            <p>Welcome to my portfolio! I'm Håkon, a web developer from NTNU Gjøvik. Here, you can explore my skills and browse through my current projects. If you have any questions or would like to collaborate, feel free to get in touch with me.</p>
          </div>
        </div>
        <ScrollLink className='contactBtn' to="contact" spy={true} smooth={true} duration={500} offset={-200}>Contact</ScrollLink>
      </section>

    </>
  );
}

export default Me;